var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.25 13.15C18.94 9.51999 15.56 7.42999 12 7.42999C10.22 7.42999 8.49 7.94999 6.91 8.91999C5.33 9.89999 3.91 11.33 2.75 13.15C1.75 14.72 1.75 17.27 2.75 18.84C5.06 22.48 8.44 24.56 12 24.56C13.78 24.56 15.51 24.04 17.09 23.07C18.67 22.09 20.09 20.66 21.25 18.84C22.25 17.28 22.25 14.72 21.25 13.15ZM12 20.04C9.76 20.04 7.96 18.23 7.96 16C7.96 13.77 9.76 11.96 12 11.96C14.24 11.96 16.04 13.77 16.04 16C16.04 18.23 14.24 20.04 12 20.04Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.14C10.43 13.14 9.15002 14.42 9.15002 16C9.15002 17.57 10.43 18.85 12 18.85C13.57 18.85 14.86 17.57 14.86 16C14.86 14.43 13.57 13.14 12 13.14Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e8688ac5399f788afe59486f284ac5d8.svg";
export { ForwardRef as ReactComponent };